import { render } from "./OfferCountdown.vue?vue&type=template&id=b7cb0046"
import script from "./OfferCountdown.vue?vue&type=script&lang=js"
export * from "./OfferCountdown.vue?vue&type=script&lang=js"
script.render = render

export default script